export class ProjectDetailsWorkCardModel {
    seq?: number;
    CARD_STEP_ID?:any;
    WORK_CARD_ID: number;
    WORK_ORDER_NUMBER?: string;
    ZONE_NUMBER?: string;
    ITEM_NUMBER?: string;
    WORK_ORDER_TYPE?: string;
    CUSTOMER_WORK_CARD?: string;
    CONTRACT_GROUP?: string;
    APPLIED_TIME?: number;
    APPROVED_TIME?: number;
    CARD_STEP_ACTION_GROUP_ID?: number;
    STATUS?: string;
    WIP_STATUS?: string;
    WIP_REASON?: string;
    WORK_CARD_EMPLOYEE_COUNT?: number;
    WORK_CARD_EMP_PUBLISHED_COUNT?: number;
    WORK_CARD_EMPLOYEE_NAME?: string;
    PROJECT_NUMBER?: string;
    DIV_NO?: number;
    WORK_CARD_DESCRIPTION?: string;
    PRIMARY_SKILL_CODE?: string;
    ALL_SKILL_CODES?: string;
    AIRCRAFT_TYPE?: string;
    ATA_CODE?: string;
    OPEN_DATE?: string;
    CLOSE_DATE?: string;
    MAINTENANCE_COMPLETE_DATE?: string;
    TARGET_START_DAY?: string;
    TARGET_START_SHIFT?: string;
    TARGET_END_DAY?: string;
    TARGET_END_SHIFT?: string;
    ACTUAL_START_DAY?: string;
    ACTUAL_START_SHIFT?: string;
    ACTUAL_END_DAY?: string;
    ACTUAL_END_SHIFT?: string;
    ON_THE_FLOOR_FLAG?: string;
    TOKEN: string;
    PIN_STATUS_FLAG?: string;
    IS_PINNED?: boolean;
    IS_CHECKED?: boolean;
    ACTUAL_INDUCTION_DATE?: string;
    // PROJECT_SUMMARY_CODE maps to the milestone associated with the work card.
    PROJECT_SUMMARY_CODE?: string;
    /**Task-20556 */
    BAY?: string;
    CUST_REP_AUDIT_STATUS?: string;
    FINAL_AUDIT_STATUS?: string;
    INDUCTION_DATE?: string;
    PROD_CONTROLLER_AUDIT_STATUS?: string;
    DISPLAY_STEP_NUMBER?:string;
    ROWNUMBER?: number;
    TAIL_NUMBER?: string;
    TECH_AUDIT_STATUS?: string;
    TOTAL_CYCLES?: string;
    TOTAL_TIME?: string;
    STEP_NAME?: string;
    STEP_DATE?: string;
    TECH_AUDIT_DATE_FORMATTED?: string;
    PROD_CONTROLLER_AUDIT_DATE_FORMATTED?: string;
    CUST_REP_AUDIT_DATE_FORMATTED?: string; 
    FINAL_AUDIT_DATE_FORMATTED?: string;
    persona?: string;
    GENERATED_BY_ZONE_NUMBER?: string;
    /**Task-40813 */
    PROD_CONTROLLER_AUDIT_FIRST_NAME?: string;
    PROD_CONTROLLER_AUDIT_LAST_NAME?: string;
    TECH_AUDIT_FIRST_NAME?: string;
    TECH_AUDIT_LAST_NAME?: string;
    CUST_REP_AUDIT_FIRST_NAME?: string;
    CUST_REP_AUDIT_LAST_NAME?: string;
    FINAL_AUDIT_FIRST_NAME?: string;
    FINAL_AUDIT_LAST_NAME?: string;
    /**Task-36704 */
    AIRWORTHINESS_DIRECTIVE_FLAG?: string;
    STAMPED_BY_REP_DATE?: string;
    STAMPED_NUMBER_ID_REP?: string;
    REJECT_REASON?: string
    // added properties for task-23409
    DISCREPANCY?: string;
    AIRCRAFT_LOCATION?: string;
    PART_REQUIRED_FLAG?: string;
    IDT_FLAG?: string;
    MAJOR_REPAIR_FLAG?: string;
    SDR_FLAG?: string;
    LEAK_CHECK_FLAG?: string;
    CORROSION_LEVEL?: string;
    FLIGHT_CRITICAL_TASK_FLAG?: string;
    ALTERATION_FLAG?: string;
    RII_FLAG?: string;
    CRITICAL_FLAG?: string;
    ESTIMATED_TIME?: number;
    SKILL_CODE?: string;
    PRIORITY?: number;
    DISCREPANCY_LINES_ID?:string;
    ELAPSED_TIME_ON_WORK_CARD?: string;
    EMPLOYEE_ACTIVELY_ON_CARD?: string
    IS_SELECTED?: boolean;
    HANGAR_BAY?:string;
    CORRECTIVE_ACTION?: string;
    PRIMARY_INSPECTION_FLAG?: string;
    PLANNED_ACTION?:string;
    CORROSION_FLAG?: string;
    DELAMINATION_FLAG?: string;

    // WPM planner properties
    DISPLAY_SEQUENCE?: number;
    REVISION_DATE?: string;
    REVISION_NUMBER?: number;
    ZONE_ITEM?: string;
    showSpinner?: boolean;
    active?: string;
    WORK_CARD_NUMBER?: string;
    CUSTOMER_WORK_ORDER?: string;
    CUSTOMER_NUMBER?: number;
    CUSTOMER_NAME?: string;
    CUSTOMER_SHORT_NAME?: string;
    CUSTOMER_REVIEW_FLAG?: string;
    SERIAL_NUMBER?: number;
    SERIAL_NUMBER_PREFIX?: string | null;
    SERIAL_NUMBER_WITH_PREFIX?: string | null;
    WORK_CARD_UPLOAD_COUNT?: number | string;
    WORK_CARD_ATTACHMENT_FILES?: string;
    WORK_CARD_ATTACHMENT_COUNT?: number | string;
    FORMATTED_REVISION_DATE?: string;
    PLAN_CHECK_FLAG?: string;
    WORK_CARD_BARCODE?: string;
    digitalCardFlag?: string;
    DIGITAL_CARD_FLAG?: string;
    // Work card step
    CURRENT_ACTIVITY_CODE?: string;
    PREVIOUS_ACTIVITY_CODE?: string;
    isLaborDirect?:boolean;
    HANGAR?: string;
    CURRENT_ACTIVITY_COMMENT?: string;
    GROUP_ID?: any;
    REQUEST_TYPE?: string;
    reason?:string;
    INSPECTED_BY_EMPLOYEE_NUMBER?: string | number;
    PAPERWORK_FLAG?: string;
    DOCUMENT_TYPE?: any;
    // Added flags for UI task 41277
    WORK_CARD_FLAGS?: WorkCardFlagsModel[];
    presetHeaderFilter?: string;
    FLAG_STRING?: string;
    CUSTOMER_DATAENTRY_SYSTEM_NAME?: string;
    CUST_DATAENTRY_FLAG?: string;
    DELAMINATION_CORROSION_DATA?: DelaminationCorrosionModel;
    DMG_FLAG?: string;
    DIP_FLAG?: string;
    DIP_COMPLETED_FLAG?: string;
    ESFR_FLAG?: string;
    MANUFACTURER_ZONE_AREA?: string;
    DEFERRAL_CODE?: string;
    REQUESTED_BY_COLOR_CODE?:any;
    INSPECTION_TYPE?:any
    CURRENT_ACTIVITY_CODE_Color?:any
}

export class header {
    hangerName: string;
    hangerCount: number;
}

/**Task-20556 */
export class KickbackQueueResModel {
    count: string;
    paginationData: ProjectDetailsWorkCardModel[];
    headers: any;
}

export enum AuditType {
    pc = 'PC',
    tech = 'TECH',
    records = 'RECORDS',
    customer = 'CUSTOMER',
}

/**Task-20556 */
export enum KickbackSteps {
    TECH_AUDIT_STATUS = 'TECH',
    PROD_CONTROLLER_AUDIT_STATUS = 'PC',
    CUST_REP_AUDIT_STATUS = 'CUST',
    FINAL_AUDIT_STATUS = 'FINAL'
}

/** Task-20540 */
export enum CardClosureStatus {
    NO_PROGRESS = 'NO_PROGRESS',
    IN_PROGRESS = 'IN_PROGRESS',
    ACCEPTED = 'ACCEPT',
    REJECTED = 'REJECT',
    NOT_STARTED = 'NOT_STARTED',
    NOT_REQUIRED = 'NOT_REQUIRED'
}

export class RecordsProjectDetailsModel {
    DIV_NO: number;
    WORK_ORDER_NUMBER: string;
    WORK_ORDER_TYPE: string;
    DISPLAY_SEQUENCE: number;
    SERIAL_NUMBER: number;
    WORK_CARD_DESCRIPTION: string;
    CLOSE_DATE: string;
    TOKEN: number | string;
    ROWNUMBER: number;
    CLOSE_DATE_FORMATTED: any;
    ZONE_ITEM?: string;
    ZONE_NUMBER?: number | string;
    ITEM_NUMBER?: number | string;
}

export class RecordsProjectDetailsRespModel {
    count: string;
    paginationData: RecordsProjectDetailsModel[];
    headers: any;

}

//Event History api responce model
export class EventHistoryResModel {
    ADDENDUM: string;
    CUSTOMER_ACCESSIBLE: string;
    DATE_MODIFIED: string;
    DATE_MODIFIED_DISPLAY: string;
    DIV_NO: number;
    EVENT_COMMENT: string;
    EVENT_CTA?: string;
    EVENT_TYPE: string;
    ISSUE_CODE: string;
    ITEM_CODE: string;
    REASON_CODE: string;
    ITEM_NUMBER: string;
    LINK_REFERENCE: string;
    MODIFIED_BY: string;
    PROJECT_NUMBER: string;
    TOKEN: string | number;
    WORK_ORDER_NUMBER: string;
    ZONE_NUMBER: string;
    addendumsDisplay?: string;
    HEADER_COLOR?: string;
    VERIFIER_APPROVALREJECT_REASON?:string;
    EVENT_COMMENT_LIST?: WCHistroyEventCommentModel[];
    OPERATION?: string;
    MODIFIED_BY_EMPLOYEE_NUMBER?: number;
    MODIFIED_BY_FIRST_NAME?: string;
    MODIFIED_BY_LAST_NAME?: string;
    CORRECTIVE_ACTION?: string;
    ID?: number;
    WORK_CARD_ID?: number;
    PARENT?: string;
    PARENT_ID?: number;
    VERIFIER_APPROVAL_REJECT_REASON?: string;
    ROUTINE_CARD_STAMP_NUMBER?: number;
    CIR_PAGE_NUMBER?: number;
    FORMATED_EVENT_TYPE?: string;
}

export class ActiveWorkCardModel {
    CLOCK_IN: string;
    CLOCK_OUT: string;
    CREW_CODE: string;
    DIV_NO: number;
    EMPLOYEE_DEPARTMENT: string;
    EMPLOYEE_NAME: string;
    EMPLOYEE_NUMBER: number;
    FIRST_NAME: string;
    HOURS_SPENT: string;
    ITEM_NUMBER: string;
    LABOR_COLLECTION_ID: string;
    LAST_NAME: string;
    MIDDLE_INITIAL: string;
    SHIFT_CODE: string;
    SKILL_CODE: string;
    SUFFIX: string;
    TOKEN: string;
    WORK_CARD_ID: string;
    WORK_DATE: string;
    WORK_ORDER_NUMBER: string;
    ZONE_NUMBER: string;
    PROJECT_NUMBER?:string;
}

export class ProjectWorkCardDetailsApiRespModel {
    count: string;
    paginationData: ProjectDetailsWorkCardModel[];
    headers: string[];
}

export class ProjectWorkCardDetailsRemoveModel {
    field: string;
    val: ProjectDetailsWorkCardModel;
}

export class WCHistroyEventCommentModel {
    eventComment: string;
    isShowBullet: boolean;
}

// Added flags for UI task 41277
export class WorkCardFlagsModel {
    AIRWORTHINESS_DIRECTIVE_FLAG?: string;
    CLOSE_FLAG?: string;
    CPCP_FLAG?: string;
    CUSTOMER_REVIEW_FLAG?: string;
    FLIGHT_CRITICAL_TASK_FLAG?: string;
    IDT_FLAG?: string;
    LEAK_CHECK_FLAG?: string;
    LUBE_CARD_FLAG?: string;
    OPEN_FLAG?: string;
    PRIMARY_INSPECTION_FLAG?: string;
    RII_FLAG?: string;
    CARD_CIR_STEP_FLAG?: string;
    CORROSION_FLAG?: string;
    DELAMINATION_FLAG?: string;
    CUST_DATAENTRY_FLAG?: string;
    ALTERATION_FLAG?: string;
}

export class CorrosionDataModel {
  beyondSrmLimitFlag: string;
  blendOut90LimitFlag: string;
  structureReinforcementFlag: string;
  evidencePreviousBlend: string;
  structureReplacedFlag: string;
  leakFlag: string;
  finishFlag: string;
  pluggedDrainFlag: string;
  uniqueEventFlag: string;
  uniqueEventDescription: string;
  otherFlag: string;
  otherDescription: string;
  corrosionExtentWideFlag: string;
  corrosionExtentLocalFlag: string;
  corrosionLevel1Flag: string;
  corrosionLevel2Flag: string;
  partNumber: string;
  partDescription: string;
  discrCorrosionDetailsId: string | number;
}

export class DelaminationDataModel{
  removeStructureCompFlag: string;
  removeStructureCompPart: string;
  removeStructureCompSno: string;
  requireSupplementalInspFlag: string;
  supplementInspThreshold: string;
  supplementInspThresholdUnit: string;
  supplementInspRepeat: string;
  supplementInspRepeatUnit: string;
  gougeFlag: string;
  dentFlag: string;
  creaseFlag: string;
  crackFlag: string;
  bulgeFlag: string;
  chafeFlag: string;
  frettingFlag: string;
  wrinkleFlag: string;
  brokenFlag: string;
  delaminatedFlag: string;
  otherFlag: string;
  otherDescription: string;
  srmRepairFlag: string;
  srmRepairDetails: string;
  sriRepairFlag: string;
  sriRepairDetails: string;
  delaminationId: string | number;
}

export class DamageLocationModel{
  DISCREPANCY_LINE_ID: string | number;
  STATION_FROM: string;
  STATION_TO: string;
  STRINGER_FROM_LEFT_FLAG: string;
  STRINGER_FROM_RIGHT_FLAG: string;
  STRINGER_FROM: string;
  STRINGER_TO_LEFT_FLAG: string;
  STRINGER_TO_RIGHT_FLAG: string;
  STRINGER_TO: string;
  BUTTLINE_FROM_LEFT_FLAG: string;
  BUTTLINE_FROM_RIGHT_FLAG: string;
  BUTTLINE_FROM: string;
  BUTTLINE_TO_LEFT_FLAG: string;
  BUTTLINE_TO_RIGHT_FLAG: string;
  BUTTLINE_TO: string;
  WATER_LINE_FROM: string;
  WATER_LINE_TO: string;
  ENGINEERING_DOCUMENT_FLAG: string;
  ENGINEERING_DOCUMENT_DETAILS: string;
  DAMAGE_LOCATION_ID: string | number;
}

export class DelaminationCorrosionModel{
  DAMAGE_LOCATION : DamageLocationModel;
  CORROSION_DATA : CorrosionDataModel;
  DELAMINATION_DATA: DelaminationDataModel;
}

export class BulkWithdrawEligibilityResModel {
    workCardId: number;
    eligibility_Flag: string;
    withdraw_Flag: string;
    workCardIdRes: number;
    eligibility_FlagRes: string;
    withdraw_FlagRes: string;
    successFlag: string;
    errorMessage: string;
}
export interface BulkWithdrawResModel {
    ANNOTATION_RESPONSE_LIST: AnnotationResponse[];
}

export interface AnnotationResponse {
    MESSAGE: string;
    WORK_CARD_ID: string;
    IS_SUCCESS: boolean;
}

export interface WithdrawResult {
    workCardId: number;
    successFlag: 'Y' | 'N';
    errorMessage: string;
}
export class WithdrawMultiCardDetails {
    workCardId: number;
    eligibility_Flag: string;
    withdraw_Flag: string;
    workCardIdRes: number;
    eligibility_FlagRes: string;
    withdraw_FlagRes: string;
    successFlag: string;
    errorMessage: string;
}

export class WPMWorCardsModel{
  persona : string;
  divNo : number;
  workCardId : number;
  projectNumber :  string;
  workOrderNumber : string;
  workOrderType :  string;
  zoneNumber :  string;
  itemNumber : string;
  serialNumber : number;
  serialNumberPrefix?: string | null;
  serialNumberWithPrefix?: string | null;
  customerWorkCard : string;
  customerReviewFlag : string;
  token : string;
  revisionNumber : string;
  customerWorkOrder : string;
  displaySequence : number;
  workCardDescription : string;
  contractGroup : string;
  ataCode : string;
  workCardEmpPublishedCount : number;
  primaryInspectionFlag : string;
  revisionDate : Date;
  primarySkillCode : string;
  allSkillCodes : string;
  workCardUploadCount : number;
  workCardAttachmentFiles : string;
  workCardAttachmentCount : number;
  formattedRevisionDate : string;
  planCheckFlag :  string;
  workCardBarcode : string;
  status :  string;
  wipStatus : string;
  wipReason: string;
  workCardEmployeeName: string;  
  zoneItem: string;
  isCheckboxDisabled?: string;  
    
  // New digitalCardFlag property to determine if we display digital steps vs PDF
  digitalCardFlag?: string;  
  digitalCardToggleStatus?: string;
}

export class CustomerWorkCardsModel{
  divNo : number;
  workCardId : number;
  projectNumber :  string;
  workOrderNumber : string;
  workOrderType :  string;
  zoneNumber :  string;
  itemNumber : string;
  serialNumber : number;
  serialNumberPrefix?: string | null;
  serialNumberWithPrefix?: string | null;
  customerWorkCard : string;
  customerReviewFlag : string;
  workCardDescription : string;
  workCardEmpPublishedCount : number;
  primarySkillCode : string;
  allSkillCodes : string;
  status :  string;
  wipStatus : string;
  wipReason :  string;
  maintenanceCompleteDate : Date;
  cardCirStepFlag: string;
  paperworkFlag: string;
  alterationFlag : string;
  flightCriticalTaskFlag : string;
  idtFlag : string;
  leakCheckFlag : string;
  primaryInspectionFlag : string;
  riiFlag : string;
  corrosionFlag : string;
  delaminationFlag : string;
  dipFlag : string;
  esfrFlag : string;
  dmgFlag : string;
  sdrFlag : string;
  criticalFlag : string;
  majorRepairFlag : string;
  partRequiredFlag : string;
  airworthinessDirectiveFlag: string;
  custRepAuditStatus: string;
  finalAuditStatus: string;
  presetHeaderFilter?: string;
  digitalCardFlag?: string;
  custDataentryRequiredFlag: string | null;
  custDataentrySystemName: string;
  deferralCode: string | null;
}

export class CardClosureQueueWorkCardsModel{
    persona: string;
    divNo: number;
    workCardId: number;
    projectNumber: string;
    workOrderNumber: string;
    workOrderType: string;
    zoneNumber: string;
    itemNumber: string;
    serialNumber: number;
    serialNumberPrefix?: string | null;
    serialNumberWithPrefix?: string | null;
    customerWorkCard: string;
    customerReviewFlag: string;
    token: string;
    bay: string;
    primarySkillCode: string;
    allSkillCodes: string;
    workCardDescription: string;
    workCardBarcode: string;
    techAuditStatus: string;
    techAuditFirstName: string;
    techAuditLastName: string;
    prodControllerAuditStatus: string;
    prodControllerAuditFirstName: string;
    prodControllerAuditLastName: string;
    custRepAuditStatus: string;
    custRepAuditFirstName: string;
    custRepAuditLastName: string;
    finalAuditStatus: string;
    finalAuditFirstName: string;
    finalAuditLastName: string;
    paperworkFlag: string;
    techFlag: string;
    pcFlag: string;
    finalFlag: string;
    contractGroup: string;
    correctiveAction: string;
    workCardEmpPublishedCount: number;
    onTheFloorFlag: string;
    wipStatus: string;
    wipReason: string;
    status: string;
    maintenanceCompleteDate?: Date;
    displaySequence?: number;
    aircraftType?: string;
    customerNumber?: number;
    airworthinessDirectiveFlag?: string;
    corrosionFlag?: string;
    corrosionLevel?: string;
    criticalFlag?: string;
    custDataentryFlag?: string;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  delaminationFlag?: string;
    flightCriticalTaskFlag?: string;
    idtFlag?: string;
    alterationFlag?: string;
    cardCirStepFlag?: string;
    dipFlag?: string;
    esfrFlag?: string
    dmgFlag?: string;
    sdrFlag?: string;
    riiFlag?: string;
    primaryInspectionFlag?: string;
    leakCheckFlag?: string;
    majorRepairFlag?: string;
    partRequiredFlag?: string;
    digitalCardFlag?: string;
    WORK_CARD_FLAGS?: WorkCardFlagsModel[];
    presetHeaderFilter?: string;
    FLAG_STRING?: string;
    deferralCode: string | null;
}
// Work Card Microservice Request/Response models

export class WorkCardMsRequestModel {
    projectNumber?: string;
    divNo?: number;
    token?: string;
    persona?: string;
    pageNo?: number;
    pageSize?: number;
    sortColumn?: string;
    sortOrder?: string;
    countFilterField?: string;
    status?: string;
    workOrderType?: string;
    zoneNumber?: string;
    skill?: string;
    assigned?: string;
    barcode?: string;
    headers?: boolean;
    workCardBarcode?: string;
}

export class WorkCardAssignmentListMsReqModel {
    projectNumber?: string;
    divNo?: number;
    token?: string;
    persona?: string;
    pageNo?: number;
    pageSize?: number;
    sortingOrder?: string;
    sortingField?: string;
    headers: boolean;
    assign?: boolean;
    logOnAllowed?: boolean;
    workCardId?: number | string;
    employeeNumber?: number | string;
    unpublished?: boolean;
}

export class WorkCardAssignmentDetailsMsModel {
    divNo?: number ;
    workCardId?: number;
    projectNumber?: string;
    workOrderNumber?: string;
    workOrderType?: string;
    digitalCardFlag?: string;
    zoneNumber?: string;
    itemNumber?: string;
    serialNumber?: number;
    customerWorkCard?: string;
    customerReviewFlag?: string;
    contractGroup?: string;
    appliedTime?: number;
    approvedTime?: number;
    status?: string;
    wipStatus?: string;
    wipReason?: string;
    workCardEmployeeCount?: number;
    workCardEmpPublishedCount?: number;
    workCardEmployeeName?: string;
    workCardDescription?: string;
    primarySkillCode?: string;
    allSkillCodes?: string;
    aircraftType?: string;
    ataCode?: string;
    pinStatusFlag?: string;
    onTheFloorFlag?: string;
    plannedAction?: string;
    customerProvidedFlag?: string;
    logonAllowedFlag?: string;
    primaryInspectionFlag?: string;
    targetEndDate?: string;
    formattedTargetEndDate?: string;
    targetEndDay?: string;
    targetStartDate?: string;
    formattedTargetStartDate?: string;
    targetStartDay?: string;
    timeOnCardPercent?: number;
    maintenanceCompleteDate?: string;
    formattedMaintCompleteDate?: string;
    workCardBarcode?: string;
    paperworkFlag?: string;
    leadSuprvsrPreauditFlag?: string;
    employeeActivelyOnCard?: string;
    isSelected?: boolean;
    persona?: string;
}

export class WorkCardMsResponseModel {
    divNo?: number;
    workCardId?: number;
    projectNumber?: string;
    workOrderNumber?: string;
    workOrderType?: string;
    zoneNumber?: string;
    itemNumber?: string;
    serialNumber?: number;
    serialNumberPrefix?: string | null;
    serialNumberWithPrefix?: string | null;
    customerWorkCard?: string;
    customerReviewFlag?: string;
    aircraftType?: string;
    allSkillCodes?: string;
    appliedTime?: number;
    approvedTime?: number;
    ataCode?: string;
    contractGroup?: string;
    maintenanceCompleteDate?: string;
    onTheFloorFlag?: string;
    paperworkFlag?: string;
    plannedAction?: string;
    primaryInspectionFlag?: string;
    primarySkillCode?: string;
    status?: string;
    targetEndDay?: string;
    targetStartDay?: string;
    wipStatus?: string;
    workCardBarcode?: string;
    customerWorkOrder?: string;
    displaySequence?: number;
    revisionDate?: string;
    revisionNumber?: number;
    wipReason?: string;
    active?: string;
    correctiveAction?: string;
    workCardDescription?: string;
    riiFlag?: string;
    stepName?: string;
    actualEndDay?: string;
    actualEndShift?: string;
    actualInductionTimestamp?: string;
    actualStartDay?: string;
    actualStartShift?: string;
    aircraftLocation?: string;
    airworthinessDirectiveFlag?: string;
    alterationFlag?: string;
    closeTimestamp?: string;
    corrosionFlag?: string;
    corrosionLevel?: string;
    criticalFlag?: string;
    custDataentryFlag?: string;
    custDataentryRequiredFlag: string | null;
    custDataentrySystemName: string;
    customerNumber?: number;
    delaminationFlag?: string;
    flightCriticalTaskFlag?: string;
    idtFlag?: string;
    inductionTimestamp?: string;
    leakCheckFlag?: string;
    majorRepairFlag?: string;
    openTimestamp?: string;
    partRequiredFlag?: string;
    priority?: number;
    sdrFlag?: string;
    tailNumber?: string;
    targetEndShift?: string;
    targetStartShift?: string;
    pinEmployeeNo?: string;
    workCardEmployeeCount?: number;
    workCardEmpPublishedCount?: number;
    workCardEmployeeName?: string;
    workCardAttachmentCount?: number;
    workCardAttachmentFiles?: any;
    workCardUploadCount?: number;
    bay?: string;
    estimatedTime?: number;
    workCardNumber?: string;
    station?: string;
    dipFlag?: string;
    esfrFlag?: string;
    dmgFlag?: string;
    zoneItem?: string;
    checkType?: string;
    originatingDocument?: string;
    sourceCustomerWorkCard?: string;
    sourceCardId?: number;
    createdBy?: string;
    formattedRevisionDate?: string;
    correctedByEmployeeNumber?: string;
    formattedMaintCompleteDate?: string;
    formattedTargetStartDate?: string;
    formattedTargetEndDate?: string;
    cardBudgetStatus?: string;
    pinStatusFlag?: string;
    planCheckFlag?: string;
    customerProvidedFlag?: string;
    maintenanceCardFlag?: string;
    robbedPartCardFlag?: string;
    cardCirStepFlag?: string;
    techFlag?: string;
    pcFlag?: string;
    finalFlag?: string;
    divSystemDate?: string;
    techAuditStatus?: string;
    techAuditFirstName?: string | null;
    techAuditLastName?: string | null;
    prodControllerAuditStatus?: string;
    prodControllerAuditFirstName?: string | null;
    prodControllerAuditLastName?: string | null;
    custRepAuditStatus?: string;
    custRepAuditFirstName?: string | null;
    custRepAuditLastName?: string | null;
    finalAuditStatus?: string;
    finalAuditFirstName?: string | null;
    finalAuditLastName?: string | null;
    discrepancyAllowedFlag?: string;
    logonAllowedFlag?: string;
    cardRepEstimateFlag?: string;
    cardOpenCirFlag?: string;
    cardAwaitingCirFlag?: string;
    cardOpenFinalAuditFlag?: string;
    pendingFinalAuditFlag?: string;
    derivedActualStartDay?: string | null;
    leadSuprvsrPreauditFlag?: string;
    projectSummaryCode?: string | null;
    summaryCodeDescription?: string | null;
    usrCreated?: string;
    dtCreated?: string;
    usrModified?: string;
    dtModified?: string;
    cardSteps?: string | null;
    WORK_CARD_FLAGS?: WorkCardFlagsModel[];
    presetHeaderFilter?: string;
    FLAG_STRING?: string;
    CUSTOMER_DATAENTRY_SYSTEM_NAME?: string;
    CUST_DATAENTRY_FLAG?: string;
    DELAMINATION_CORROSION_DATA?: DelaminationCorrosionModel;
    DMG_FLAG?: string;
    DIP_FLAG?: string;
    DIP_COMPLETED_FLAG?: string;
    ESFR_FLAG?: string;
    deferralCode: string | null;
}

export class RecordsWorkCardResponseModel {
    aircraftType: string;
    closeDate: string;
    closeDateFormatted: any;
    contractGroup: string;
    customerNumber: number;
    customerReviewFlag: string;
    customerWorkCard: string;
    customerWorkOrder: string;
    displaySequence: number;
    divNo: number;
    itemNumber: string;
    primarySkillCode: string;
    projectNumber: string;
    serialNumber: number;
    serialNumberPrefix?: string | null;
    serialNumberWithPrefix?: string | null;
    status: string;
    wipReason: string;
    wipStatus: string;
    workCardDescription: string;
    workCardEmpPublishedCount: number;
    workCardId: number;
    workOrderNumber: string;
    workOrderType: string;
    zoneNumber: string;
    zoneItem?: string;
}

export class RecordsResponseModel {
    data?: RecordsWorkCardResponseModel[];
    errorCode?: string;
    headers?: {};
    message?: string;
    pageNumner: number;
    pageSize: number;
    success: boolean;
    totalPages: number;
}

// Inspection Queue MS Work Card Response Model
export class InspectionQueueMSWorkCardModel {
    data?: InspectionQueueMSWorkCardResponseModel[];
    errorCode?: string;
    headers?: {};
    message?: string;
    pageNumber: number;
    pageSize: number;
    success: boolean;
    totalPages: number;
}

export class InspectionQueueMSWorkCardResponseModel {
    CARD_STEP_ACTION_GROUP_ID:any;
    WORK_CARD_ID:any;
    PROJECT_NUMBER:any;
    DIV_NO:any;
    active: string;
    allSkillCodes: string;
    approvedByEmployeeFirstname: string | null;
    approvedByEmployeeId: number | null;
    approvedByEmployeeLastname: string | null;
    approvedByEmployeeName: string | null;
    approvedByEmployeeNumber: string | null;
    approvedHours: number | null;
    bay: string;
    cardDescription: string;
    cardStepId: string | null;
    completedQuantity: number | null;
    correctiveAction: string | null;
    createdByEmployeeFirstname: string;
    createdByEmployeeId: number;
    createdByEmployeeLastname: string;
    createdByEmployeeName: string;
    createdByEmployeeNumber: string;
    createdByEmployeeTag: string;
    createdDateFormatted: string;
    currentActivityCode: string | null;
    currentActivityComment: string | null;
    currentActivityDate: string | null;
    currentActivityEmpName: string | null;
    currentActivityEmployee: string | null;
    currentActivityResult: string | null;
    currentEmployeeColorCode: string | null;
    currentEmployeeFty: string | null;
    custRepApprovalFlag: string | null;
    customerReviewFlag: string | null;
    customerWorkCard: string | null;
    daysSinceCreated: number | null;
    daysSinceLastActivity: number | null;
    description: string;
    digitalCardFlag?: string;
    dipsCompletedFlag: string | null;
    displayStepNumber: number;
    divNo: number;
    documentItemNumber: string | null;
    documentType: any;
    dtCreated: string;
    dtModified: string;
    employeeFullName: string | null;
    estimatedHours: number | null;
    formattedStatus: string | null;
    groupId: string | null;
    hangar: string;
    id: number;
    inspectedBy: string | null;
    inspectedByEmployeeNumber: string | null;
    inspectedByFull: string | null;
    inspectedDate: string | null;
    inspectionRequestType: string;
    inspectionType: string | null;
    inspectorCustomerEmplNumber: string | null;
    inspectorSignoffFlag: string;
    inspectorStampCategory: string | null;
    inspectorStampNumber: string | null;
    inspectorStampType: string | null;
    isAwaitingCir: string;
    isDigital: boolean;
    isPdf: boolean;
    isMaintenance: string;
    isNdt: string;
    isOverdue: boolean | null;
    isPrimaryInspection: string;
    itemNumber: string;
    latestStepDescription: string;
    latestStepModifiedDate: string;
    latestStepModifiedEmpFname: string;
    latestStepModifiedEmpId: string;
    latestStepModifiedEmpLname: string;
    latestStepModifiedEmpNbr: string;
    latestStepModifiedFdate: string;
    leadRejectFlag: string;
    leadSignoffFlag: string | null;
    licMechCustomerEmplNumber: string | null;
    licMechanicStampNumber: string | null;
    mechanicCustomerEmplNumber: string | null;
    mechanicStampCategory: string;
    mechanicStampNumber: string;
    mechanicStampType: string;
    operationCode: string | null;
    pageNumber: number | null;
    previousActivityCode: string | null;
    previousActivityComment: string | null;
    previousActivityDate: string | null;
    previousActivityEmployee: string | null;
    previousActivityResult: string | null;
    previousEmployeeColorCode: string | null;
    primarySkillCode: string;
    priorityLevel: number | null;
    processedByEmployeeId: number;
    processedByEmployeeName: string;
    processedByEmployeeNumber: string;
    projectNumber: string;
    requestType: string | null;
    requestedBy: string | null;
    requestedByEmployeeNumber: string | null;
    requestedByFullName: string | null;
    requestedDate: Date | string | null;
    riiFlag: string | null;
    scrappedQuantity: number | null;
    serialNumber: string | null;
    sortOrder: string;
    sourceCardId: number | null;
    sourceCardStepId: number | null;
    sourceItemNumber: string | null;
    sourceStepDescription: string | null;
    sourceStepId: number | null;
    sourceStepIdName: string | null;
    sourceStepName: string | null;
    sourceStepNumber: number | null;
    sourceWorkOrderNumber: string | null;
    sourceZoneNumber: string | null;
    stampedByInspectorDate: string | null;
    stampedByInspectorEmpId: number;
    stampedByInspectorEmpName: string | null;
    stampedByInspectorEmpNo: string | null;
    stampedByInspectorFlag: string;
    stampedByLicMechEmpId: number;
    stampedByLicMechEmpName: string | null;
    stampedByLicMechanicDate: string | null;
    stampedByLicMechanicEmpNo: string | null;
    stampedByLicMechanicFlag: string;
    stampedByMechanicDate: string;
    stampedByMechanicEmpId: number;
    stampedByMechanicEmpName: string;
    stampedByMechanicEmpNo: number;
    stampedByMechanicFlag: string;
    stampedByRepDate: string | null;
    stampedByRepFlag: string | null;
    stampedByRepId: number;
    stampedByRepName: string | null;
    stampedByRepNumber: string | null;
    status: string;
    statusReason: string;
    stepActivityStatus: string;
    stepName: string;
    stepNumber: number;
    stepRejectCount: number;
    strikeOutFlag: string;
    techActivityComment: string | null;
    transferCount: number;
    usrCreated: string;
    usrModified: string;
    workCardCorrectiveAction: string | null;
    workCardId: number;
    workCenter: string | null;
    workCenterId: number | null;
    workCenterOperationId: number | null;
    workOrderNumber: string;
    workOrderType: string;
    zoneNumber: string;
    displayActionNumber: string;
}

